import { useNavigate } from "react-router-dom"
import MTable from "../../../components/mtable"

export default function ActivityTemplates() {

    const navigate = useNavigate()

    const mapper = { columns: [
        {
            label: "Name",
            value: (item) => item.name,
        },
        {
            label: "Description",
            value: (item) => item.description,
            width: '3fr'
        },
        {
            label: "",
            actions: [
                {
                    label: "Edit",
                    style: (_) => "outline",
                    onClick: (item) => navigate(`${item.id}`)
                }
            ],
            width: "80px"
        }
    ]}

    return (
        <div className="page-xl-centered standard-padding showing">
            <div className="flex space-between gap-xs v-spacer-m">
                <p className="section-title">Activity Templates</p>
                <button className="solid" onClick={() => navigate('create')}>Create Template</button>
            </div>
            <MTable path={'activity-templates'} mapper={mapper} />
        </div>
    )
}
